import React from 'react';
import { useLocation } from 'react-router-dom';
import { I18n } from 'i18n';
import { useSelector } from 'react-redux';
import { Layout } from '../style';
import { Log } from '../../filter-orp/views/log';
import { HistoricLog } from '../../filter-orp/views/historic-Log';
import { Sider, Main } from '../components';

const ROUTES = [
  {
    key: 'daily-graph',
    name: I18n('daily_graph', true),
    path: '/water-quality/filter-orp/daily-graph',
    component: HistoricLog,
  },
  {
    key: 'table',
    name: I18n('data_table', true),
    path: '/water-quality/filter-orp/table',
    component: Log,
  },
];

export function FilterOrp() {
  const { collapseNav } = useSelector(({ app }) => app);
  const { pathname } = useLocation();
  const location = pathname.split('/');
  return (
    <Layout>
      {!collapseNav && (
        <Sider
          ROUTES={ROUTES}
          defaultSelectedKeys={location[3]}
          title={I18n('ORP', true)}
          key={'ORP'}
        />
      )}
      <Main ROUTES={ROUTES} collapseNav={collapseNav} breadcrumb={location} />
    </Layout>
  );
}
